/**
 * Fix for "ResizeObserver loop completed with undelivered notifications" error.
 *
 * This error occurs when a ResizeObserver callback triggers a layout change that
 * immediately triggers another ResizeObserver notification in the same frame.
 *
 * By wrapping the callback in requestAnimationFrame, we delay the execution
 * to the next frame, breaking the synchronous loop.
 */

const installResizeObserverFix = () => {
  const OriginalResizeObserver = window.ResizeObserver;

  // If ResizeObserver is not available (e.g. server-side rendering or very old browsers), do nothing.
  if (!OriginalResizeObserver) {
    return;
  }

  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          // Filter out entries whose target elements have been disconnected from the DOM
          // to prevent "Unable to find node on an unmounted component" errors
          const connectedEntries = entries.filter((entry) => entry.target.isConnected);
          if (connectedEntries.length > 0) {
            callback(connectedEntries, observer);
          }
        });
      });
    }
  };
};

installResizeObserverFix();
